import React, { useState, useEffect } from 'react';
/* eslint-disable */
import * as Yup from 'yup';

// material
import { Container, Card } from '@material-ui/core';

import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, InputAdornment, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';

//CLickable Table Imports

import { makeStyles } from '@material-ui/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import AddBoxIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';






export default function CropDetailsUpdate(props) {

  async function GenerateOrderToast(values) {
    toast.success('Daily Crop Details Updated Succesfully ');
    setTimeout(() => {
    }, 3000);
}


  

 

  const productcatogerySearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
    ddl: Yup.number().min(1, 'Please Select Farmer').required('Farmer Required'),
    collectionCenter: Yup.number().min(1, 'Please Select Collection center').required('Collection Center Required'),
    product: Yup.number().min(1, 'Please Select Product').required('Product Required'),
    dateID: Yup.string()
  });

  const [date, setDate] = React.useState(new Date());

  const formik = useFormik({
    initialValues: {
      groupID: '1',
      ddl: '0',
      collectionCenter: '0',
      dateID: date.toISOString().split('T')[0],
      product: '0'
    },
    validationSchema: productcatogerySearchSchema,
    onSubmit: (values) => {
      //SubmitForm(values);
    }
  });

  async function SubmitForm(value) {
    toast.success('Succesfully Generate Main Order');
  }

  async function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  return (
    <Page title="Supplier |  FAPS">
      <Container>
        <CommonPageHeader
          path={'/createCropForcast'}
          btname="Add"
          pageName="Daily Crop Details Update "
          leftButtonHidden={true}
        />

        
        <FormikProvider value={formik}>
          <ToastContainer position="bottom-right" pauseOnHover />
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                  select
                  fullWidth
                  size="small"
                  label="Group *"
                  value={formik.values.groupID}
                  onChange={formik.handleChange}
                  {...getFieldProps('groupID')}
                  error={Boolean(touched.groupID && errors.groupID)}
                  helperText={touched.groupID && errors.groupID}
                >
                  <MenuItem key={0} value={0}>

                    Select Group
                  </MenuItem>
                  <MenuItem value={1}> Cargills</MenuItem>
                </TextField>
               
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Collection Center *"
                  value={formik.values.collectionCenter}
                  onChange={formik.handleChange}
                  {...getFieldProps('collectionCenter')}
                  error={Boolean(touched.collectionCenter && errors.collectionCenter)}
                  helperText={touched.collectionCenter && errors.collectionCenter}
                >
                  <MenuItem key={0} value={0}>All Collection Center</MenuItem>
                  <MenuItem value={1}> Thanamalvila</MenuItem>
                  <MenuItem value={2}> Wellawaya</MenuItem>
                </TextField>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Product *"
                  value={formik.values.product}
                  onChange={formik.handleChange}
                  {...getFieldProps('[product')}
                  error={Boolean(touched.product && errors.product)}
                  helperText={touched.product && errors.product}
                >
                  <MenuItem key={0} value={0}>Select Product</MenuItem>
                  <MenuItem value={1}> Carrot</MenuItem>
                  <MenuItem value={2}> Pumpkin</MenuItem>
                </TextField>

              </Stack>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
             
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Farmer *"
                  value={formik.values.ddl}
                  onChange={formik.handleChange}
                  {...getFieldProps('ddl')}
                  error={Boolean(touched.ddl && errors.ddl)}
                  helperText={touched.ddl && errors.ddl}
                >
                  <MenuItem key={0} value={0}>Farmer</MenuItem>
                  <MenuItem value={1}> Sugath</MenuItem>
                  <MenuItem value={2}> Nimal</MenuItem>
                </TextField>
                <TextField
                  fullWidth
                  id="outlined-start-adornment"
                  size="small"
                  label="Date *"
                  type="Date"
                  value={formik.values.dateID}
                  onChange={formik.handleChange}
                  {...getFieldProps('dateID')}
                  error={Boolean(touched.dateID && errors.dateID)}
                  helperText={touched.dateID && errors.dateID}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"></InputAdornment>
                  }}>
                </TextField>
                
              </Stack>
            </Stack>
            <br />
            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
              <Button type="submit" color="secondary" variant="outlined" onClick={() => GenerateOrderToast()}>
                Update
              </Button>
            </Stack>
          </Form>
        </FormikProvider>

        <br />
        <Divider variant="middle" />
        <br />
        {/* TAble  */}

       
          {/* <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center" spacing={2}>
            <Paper className={classes.root}>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox" />
                    <TableCell>ItemName</TableCell>
                    <TableCell align="right">Quantity</TableCell>
                    <TableCell align="right">Reamining Quantity</TableCell>
                    <TableCell align="right">Measuring Unit</TableCell>
                  
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <ExpandableTableRow
                      key={row.name}
                      expandComponent={<TableCell colSpan="5">{row.detail}</TableCell>}
                    >
                      <TableCell component="th" scope="row">{row.name}</TableCell>
                      <TableCell align="right">{row.quantity}</TableCell>
                      <TableCell align="right">{row.remaningQuantity}</TableCell>
                      <TableCell align="right">{row.measuringUnit}</TableCell>
                     
                    </ExpandableTableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          </Stack> */}
        <br />
      </Container>
    </Page>
  );
}
